module.exports = __webpack_public_path__ + "static/img/kerala.3eaca973.png";